module.exports = __webpack_public_path__ + "img/logo-dark.bb7767bc.svg";